// extracted by mini-css-extract-plugin
var _1 = "StatsIcon__clickable--Z7qwH";
var _2 = "StatsIcon__clickableCircle--LQgxL";
var _3 = "StatsIcon__main--z3JkC";
var _4 = "StatsIcon__svg--jTte2";
export { _1 as "clickable", _2 as "clickableCircle", _3 as "main", _4 as "svg" }
